<template>
  <div class="top-view">
    <div class="graph-view-text">
      <div class="graph-view_title">
        <div class="top-img"></div>
        <span>{{ $t(title) }}</span>
      </div>
    </div>
    <div class="graph-view_describe ">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor1) }}</span></div>
      <div class="graph-view_screen"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor2) }} </span></div>
    </div>
    <div class='graph-view_checkbox'>
      <div class='Projector_checkbox'>
        <el-checkbox v-model='projectorCheckedTopData'><span>{{$t('T_CHANGE_PJ_POS')}}</span></el-checkbox>
      </div>
    </div>
    <Cv
      id="topView"
      :w="depthInit"
      :h="widthInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrLightingArea="arrLightingArea"
      :arrOffsetLines="arrOffsetLines"
      :arrRectLines="arrRectLines"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrCurveRect="arrCurveRect"
      :arrRectArea="arrRectArea"
      @setArrHelpLine="setArrHelpLine"
      ref="topView"
    >
    </Cv>
    <div class="graph-slider-block" :class="{'hidden':this.hAngleFlag === false}">
      <div class="slider-title-v" :title="$t(sliderTitle)">{{ $t(sliderTitle) }}</div>
      <div class="slider-item" :title="$t(sliderMsg1)">{{ $t(sliderMsg1) }}</div>
      <el-slider
        v-model="hAngleData"
        :max="sliderMax"
        :min="sliderMin"
        vertical
        :height="sliderHeight"
        :disabled="!hAngleFlagData"
        :step="0.1"
        :show-tooltip= false>
      </el-slider>
      <div class="slider-item" :title="$t(sliderMsg2)">{{ $t(sliderMsg2) }}</div>
      <div class="graph-view_slider-input">
        <el-input v-model.number="hAngleDataSlider" class="side_input" :class="{'red_out': (!indAngleSwitch && isHAngleOut) || (indAngleSwitch && !isOnCornerAreas)}" :disabled="!hAngleFlagData" @input="testDigitalNegative($event, 'hAngleData')" @blur="testDigitalNegativeBlur">
          <template slot="suffix"><span style="line-height: 26px;">{{ sliderAppend }}</span></template>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'topView',
  data () {
    return {
      title: 'T_TOP_VIEW',
      strColor1: 'T_AVAILABLE_RANGE',
      strColor2: 'T_MSG_OUT_WALL',
      sliderTitle: 'T_ROTATION',
      sliderMsg1: 'T_RIGHT',
      sliderMsg2: 'T_LEFT',
      sliderMax: 90,
      sliderMin: -90,
      sliderAppend: '°',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: {},
      arrDashLines: [],
      arrDashRemainLines: [],
      arrLightingArea: [],
      arrOffsetLines: [],
      arrRectLines: [],
      arrCatchArea: [],
      arrCurveRect: [],
      arrRectArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      depthInit: 0,
      widthInit: 0,

      helpDisMin: 20,
      helpDisMax: 40,
      helpTextDis: 37,
      helpBesideDis: 45,
      sliderHeight: '0px',
      hAngleDataSlider: 0,
      mp: {}
    }
  },
  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'hAngle',
      'houseInfo',
      'hAngleFlag',
      'hAngleFlag',
      'drawData',
      'lenghProInit',
      'curveCenter',
      'curveRadius',
      'curveCentralAngle',
      'curveShape',
      'widthProInit',
      'projectorCheckedTop',
      'offset',
      'curveDirection',
      'curveDepth',
      'dashFlag',
      'dashData',
      'isOnCornerAreas',
      'indAngleSwitch',
      'limitData',
      'keyStoneHorizontal',
      'searchTabActive'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    hAngleFlagData () {
      return this.hAngleFlag
    },
    hAngleData: {
      get () {
        return this.hAngle
      },
      set (value) {
        this.$store.commit('SET_HANGLE', value)
      }
    },
    projectorCheckedTopData: {
      get () {
        return this.projectorCheckedTop
      },
      set (value) {
        this.$store.commit('SET_PROJECTORCHECKEDTOP', value)
      }
    },
    isHAngleOut () {
      return !this.keyStoneHorizontal
    }
  },
  created () {
    this.depthInit = this.houseInfo.roomD
    this.widthInit = this.houseInfo.roomW
  },
  mounted () {
    this.child = this.$refs.topView
    this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.hAngleDataSlider = this.hAngleData
    this.initCanvasData()
    this.$nextTick(function () {
      // this.child.drawCv()
    })
    this.unWatchDrawData = this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})

    this.unWatchHouseInfo = this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.depthInit = this.houseInfo.roomD
      this.widthInit = this.houseInfo.roomW
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, {deep: true})
  },
  destroyed () {
    this.unWatchDrawData()
    this.unWatchHouseInfo()
  },
  methods: {
    ...mapMutations([
      'SET_HANGLE'
    ]),

    initCanvasData () {
      this.depthInit = this.houseInfo.roomD
      this.widthInit = this.houseInfo.roomW
      if (!this.drawData) {
        return
      }
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      // 虚线
      this.arrDashLines = []
      this.arrLightingArea = []
      // 虚线
      this.arrDashRemainLines = []
      // Offset
      this.arrOffsetLines = []
      // 投影仪可拖动区域
      this.avlRect = null
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 斜边投影区域
      this.arrCatchArea = []
      // 曲面弧
      this.arrCurveRect = []
      // 四边形
      this.arrRectArea = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrRectLines()
      this.setArrLightingArea()
      this.setArrCurveRect()
      // this.setArrHelpLine()
      // this.setArrHelpText()
    },
    setPjRect () {
      var x = this.$commonViewJs.getAy()
      var y = this.houseInfo.roomW - this.$commonViewJs.getAx()
      var width = this.lenghProInit
      var height = this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.houseInfo.roomD,
        this.houseInfo.roomW
      )
    },
    setAvlRect () {
      if (this.$commonViewJs.isAvlExist()) {
        var k = this.$draw.toPoint(
          this.$commonViewJs.getPy(),
          this.houseInfo.roomW - this.$commonViewJs.getPx()
        )
        var l = this.$draw.toPoint(
          this.$commonViewJs.getQy(),
          this.houseInfo.roomW - this.$commonViewJs.getQx()
        )
        this.avlRect = this.$draw.toRect(
          k.x,
          k.y,
          l.x - k.x,
          l.y - k.y
        )
      }
    },
    setArrCurveRect () {
      if (Math.abs(this.curveDepth) < this.limitData) {
        return
      }
      if (this.curveShape === '1') {
        // 先清掉之前的左边的竖线
        if (this.curveDirection === '1' && this.searchTabActive === 'CurvedSurface') {
          var clearLine = this.$draw.toLine(
            0,
            0,
            0,
            this.houseInfo.roomW,
            '#EAEAEA',
            2
          )
          this.arrRectLines.push(clearLine)
        }

        // 画圆弧
        var curAng = this.curveDirection === '0' ? 180 : 0
        var curveArea = this.$draw.toCurveArea(
          this.curveCenter,
          this.houseInfo.roomW / 2,
          this.curveRadius,
          curAng,
          this.curveCentralAngle,
          this.$constant.roomLineColor,
          this.curveDirection === '0' ? '' : this.$constant.canvasBgColor,
          2
        )
        this.arrCurveRect.push(curveArea)
      }
      // else if (this.curveDirection === '0') {
      //   let rect0 = this.$draw.toRectArea(
      //     -this.curveDepth,
      //     0,
      //     this.curveDepth,
      //     this.houseInfo.roomW,
      //     this.$constant.roomLineColor,
      //     this.$constant.roomFillColor,
      //     2
      //   )
      //   this.arrRectArea.push(rect0)
      // }
    },
    setArrRectLines () {
      if (!this.drawData) {
        return
      }
      for (let i = 0; i < this.drawData[0].length; i++) {
        var rectLines = this.$draw.toLine(
          this.drawData[0][i].y,
          this.houseInfo.roomW - this.drawData[0][i].x,
          this.$commonViewJs.getAy(),
          this.houseInfo.roomW - this.graph.pjX,
          this.$constant.rectLineColor,
          0.8
        )
        this.arrRectLines.push(rectLines)
      }
    },
    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].y, this.houseInfo.roomW - this.drawData[i][j].x))
        }
      }
    },
    setArrLightingArea () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[1]
      let LightingPoints0 = []
      for (let i = 1; i < data0.length; i++) {
        LightingPoints0.push(this.$draw.toPoint(data0[i].y, this.houseInfo.roomW - data0[i].x))
      }
      LightingPoints0.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.houseInfo.roomW - this.graph.pjX))
      this.arrLightingArea.push(LightingPoints0)
    },

    setArrDashLines () {
      var dashLine0 = this.$draw.toLine(
        0,
        this.houseInfo.roomW - this.graph.pjX,
        this.houseInfo.roomD,
        this.houseInfo.roomW - this.graph.pjX
      )
      this.arrDashLines.push(dashLine0)
      var dashLine1 = this.$draw.toLine(
        this.$commonViewJs.getKy(),
        0,
        this.$commonViewJs.getKy(),
        this.houseInfo.roomW
      )
      this.arrDashLines.push(dashLine1)
      if (this.$commonViewJs.isAvlExist()) {
        var dashLine2 = this.$draw.toLine(
          this.$commonViewJs.getLy(),
          0,
          this.$commonViewJs.getLy(),
          this.houseInfo.roomW
        )
        this.arrDashLines.push(dashLine2)
      }
      if (this.$commonViewJs.isOffsetExist()) {
        var dashLine3 = this.$draw.toLine(
          this.offset,
          0,
          this.offset,
          this.houseInfo.roomW
        )
        this.arrDashLines.push(dashLine3)
      }
    },
    setArrDashRemainLines () {
      var dashLine1
      if (this.dashFlag) {
        for (let i = 1; i < this.dashData.length; i++) {
          for (let j = 1; j < this.dashData[i].length; j++) {
            dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].y, this.houseInfo.roomW - this.dashData[i][j - 1].x, this.dashData[i][j].y, this.houseInfo.roomW - this.dashData[i][j].x, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
          if (i === this.dashData.length - 1) {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.houseInfo.roomW - this.dashData[i][this.dashData[i].length - 1].x, this.dashData[1][0].y, this.houseInfo.roomW - this.dashData[1][0].x, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.houseInfo.roomW - this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i + 1][0].y, this.houseInfo.roomW - this.dashData[i + 1][0].x, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
        }
      }
    },
    setArrOffsetLines () {
      if (this.$commonViewJs.isOffsetExist()) {
        var dashLine = this.$draw.toLine(
          this.offset,
          0,
          this.offset,
          this.houseInfo.roomW,
          this.$constant.dashLineColor,
          1.2
        )
        this.arrOffsetLines.push(dashLine)
      }
    },
    setArrHelpLine (proportion) {
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)
      // 上辅助线
      var helpLine0 = this.$draw.toLine(
        0,
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      var helpLine1 = this.$draw.toLine(
        this.depthInit,
        0 - this.helpDisMin,
        this.depthInit,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)
      var helpLine2 = this.$draw.toLine(
        0,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.depthInit,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)
      // 右辅助线
      var helpLine3 = this.$draw.toLine(
        this.depthInit + this.helpDisMin,
        0,
        this.depthInit + this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      var helpLine4 = this.$draw.toLine(
        this.depthInit + this.helpDisMin,
        this.widthInit,
        this.depthInit + this.helpDisMax,
        this.widthInit,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine4)
      var helpLine5 = this.$draw.toLine(
        this.depthInit + (this.helpDisMin + this.helpDisMax) / 2,
        0,
        this.depthInit + (this.helpDisMin + this.helpDisMax) / 2,
        this.widthInit,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine5)

      // 左辅助线
      // let curDep = this.curveDirection === '0' ? -this.curveDepth : (this.curveDirection === '1' ? this.curveDepth : 0)
      let curDep = this.curveDepth ? this.curveDepth : 0
      if (this.curveDepth > 0 && this.curveShape === '1' && this.searchTabActive === 'CurvedSurface') {
        // 添加上辅助线
        var helpLineLeftc = this.$draw.toLine(
          0 + curDep,
          0 - this.helpDisMin,
          0 + curDep,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeftc)
        helpLineLeftc = this.$draw.toLine(
          0 + curDep,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeftc)
        var textName0 = this.$commonJs.changeUnitDraw(this.curveDepth, this.graph.unit, false)
        var helpText0 = this.$draw.toText(
          curDep / 2,
          0 - this.helpTextDis,
          textName0
        )
        this.arrHelpText.push(helpText0)
      }
      // curDep = this.curveDirection === '0' ? -this.curveDepth : 0
      var helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjX < this.houseInfo.roomW) this.arrHelpLines.push(helpLineLeft)
      this.mp = this.getPointCurMaxAndMin()
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomW - this.mp.maxP.x,
        0 - this.helpDisMax,
        this.houseInfo.roomW - this.mp.maxP.x,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomW - this.mp.minP.x,
        0 - this.helpDisMax,
        this.houseInfo.roomW - this.mp.minP.x,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomW,
        0 - this.helpDisMax,
        this.houseInfo.roomW,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjX > 0) this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomW,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomW - this.mp.maxP.x,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjX > this.houseInfo.roomW) this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomW - this.mp.minP.x,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomW,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjX < 0) this.arrHelpLines.push(helpLineLeft)
      this.setArrHelpText(proportion)
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点(为曲面)
    getPointCurMaxAndMin () {
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (this.drawData[i][j].x > initDMax.x) {
            initDMax = this.drawData[i][j]
          }
          if (this.drawData[i][j].x < initDMin.x) {
            initDMin = this.drawData[i][j]
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点
    getPointMaxAndMin () {
      let maxFlag = false
      let minFlag = false
      let outFlag = true
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 0; i < this.drawData[0].length; i++) {
        if (this.drawData[0][i].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
          outFlag = false
        }
      }
      if (outFlag) {
        return {
          maxP: {x: this.houseInfo.roomW, y: 0, z: 0},
          minP: {x: 0, y: 0, z: 0}
        }
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (Math.abs(this.drawData[i][j].x - this.houseInfo.roomW) < this.limitData && !maxFlag) {
            initDMax = this.drawData[i][j]
            maxFlag = true
          } else if (this.drawData[i][j].x < this.limitData && !minFlag) {
            initDMin = this.drawData[i][j]
            minFlag = true
          } else if (this.drawData[i][j].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
            if (this.drawData[i][j].x > initDMax.x && !maxFlag) {
              initDMax = this.drawData[i][j]
            }
            if (this.drawData[i][j].x < initDMin.x && !minFlag) {
              initDMin = this.drawData[i][j]
            }
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    setArrHelpText (proportion) {
      let lis = 7 * proportion
      let curDis = this.curveShape === '1' && this.curveDepth && this.searchTabActive === 'CurvedSurface' ? this.curveDepth : 0
      var textName0 = this.$commonJs.changeUnitDraw(this.houseInfo.roomD, this.graph.unit, false)
      var curDisName = this.$commonJs.changeUnitDraw(this.houseInfo.roomD - curDis, this.graph.unit, false)
      var helpText0 = this.$draw.toText(
        (this.depthInit + curDis) / 2,
        0 - this.helpTextDis,
        curDisName
      )
      this.arrHelpText.push(helpText0)
      // 单位
      textName0 = '(' + this.unitLabel + ')'
      helpText0 = this.$draw.toText(
        this.houseInfo.roomD,
        0 - this.helpTextDis,
        textName0
      )
      this.arrHelpText.push(helpText0)
      var textName1 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW, this.graph.unit, false)
      var helpText1 = this.$draw.toText(
        this.depthInit + this.helpTextDis + this.helpBesideDis,
        this.widthInit / 2,
        textName1
      )
      this.arrHelpText.push(helpText1)

      // 左辅助线
      // let curDep = this.curveDirection === '0' ? -this.curveDepth : 0
      var textNameLeft = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomW - this.mp.maxP.x, this.graph.unit, false
      )
      var helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        (this.houseInfo.roomW - this.mp.maxP.x) / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        this.mp.maxP.x - this.mp.minP.x, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        (this.houseInfo.roomW * 2 - this.mp.maxP.x - this.mp.minP.x) / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        this.mp.minP.x, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        (this.houseInfo.roomW * 2 - this.mp.minP.x) / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
    },

    onResize () {
      // TODO set conponent size
      this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px'
      this.child.resizeDraw()
    },

    testDigitalNegative (e, key) {
      e = e || '0'
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      let tempArray = e.split('.')
      this.hAngleDataSlider = e || 0
      if (e && e !== '-' && ((tempArray.length > 1 && tempArray[1]) || tempArray.length === 1)) {
        this.hAngleDataSlider = (e * 1).toFixed(1) * 1
        this[key] = (e * 1).toFixed(1) * 1
      }
    },

    testDigitalNegativeBlur () {
      if (isNaN(this.hAngleDataSlider)) {
        let e = '0'
        this.hAngleDataSlider = (e * 1).toFixed(1) * 1
        this.hAngleData = (e * 1).toFixed(1) * 1
      }
    }
  },

  watch: {
    hAngleData (newValue) {
      this.hAngleDataSlider = newValue
    }
  }
}
</script>

<style scoped>
.top-view {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-right: 1px solid #bdbdbd;
  background: #fff;
}

.top-img {
  background: url('../../assets/parts/icon/icon_top.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}

.top-view >>> .canvas_side {
  text-align: center;
  width: calc(100% - 55px);
  height: calc(100% - 60px);
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/topView.vue